const css = `.ticket-types-legend {
  background-color: var(--surface-50);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid var(--surface-200);
  width: 100%;
}
.ticket-types-legend .legend-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
  margin: 0 0 12px 0;
}
.ticket-types-legend .legend-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ticket-types-legend .legend-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.ticket-types-legend .legend-item .legend-icon {
  font-size: var(--font-size-lg);
  margin-top: 2px;
  flex-shrink: 0;
}
.ticket-types-legend .legend-item .legend-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}
.ticket-types-legend .legend-item .legend-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
}
.ticket-types-legend .legend-item .legend-description {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  line-height: var(--line-height-normal);
}
@media (max-width: 768px) {
  .ticket-types-legend {
    padding: 12px;
  }
  .ticket-types-legend .legend-title {
    font-size: var(--font-size-sm);
    margin-bottom: 12px;
  }
  .ticket-types-legend .legend-item {
    gap: 12px;
  }
  .ticket-types-legend .legend-item .legend-icon {
    font-size: var(--font-size-base);
  }
  .ticket-types-legend .legend-item .legend-label {
    font-size: var(--font-size-sm);
  }
  .ticket-types-legend .legend-item .legend-description {
    font-size: var(--font-size-xs);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
